<script lang="ts" setup>
// Logo Immonot. La taille est portée par l'appelant : la barre le veut plus
// petit sur mobile, le tiroir a la sienne.
</script>

<template>
  <img
    src="/images/logos/immonot.png"
    class="object-contain"
    alt="Immonot"
  >
</template>
